<template>
  <div ref="page">
    <div class="md-layout md-layout-item md-size-100">
      <div class="ml-auto" v-if="agendaSettings.showPDFButton">
        <md-button
          @click.prevent="print"
          class="md-round md-primary md-sm md-blue-border"
          style="margin:0px"
        >{{$t('Download PDF')}}</md-button>
      </div>
    </div>

    <div class="md-layout md-layout-item md-size-100">
      <md-field class="md-form-group md-layout-item md-size-100">
        <label>{{ $t('Search') }}</label>
        <md-input v-model="filters.search" v-on:keyup.enter="loadData(false)" />
      </md-field>

      <md-field class="md-form-group md-layout-item md-size-45 md-small-size-100">
        <label for="f_thematicPath" style="margin-right:10px">{{$t('Thematic path')}}</label>
        <md-select v-model="filters.thematicPath" name="f_thematicPath" md-dense>
          <md-option>{{$t('Show all')}}</md-option>
          <md-option v-for="v in lookups.thematicPaths" :key="v" :value="v">{{v}}</md-option>
        </md-select>
      </md-field>

      <div class="md-layout-item md-size-10 md-small-hide" />
      <md-field class="md-form-group md-layout-item md-size-45 md-small-size-100">
        <label for="f_type">{{$t('Type')}}</label>
        <md-select v-model="filters.panelType" name="f_type" md-dense>
          <md-option>{{$t('Show all')}}</md-option>
          <md-option v-for="v in lookups.panelTypes" :key="v" :value="v">{{v}}</md-option>
        </md-select>
      </md-field>

      <!--
      <div class="md-layout-item md-size-5 md-small-hide" />
      <md-field class="md-form-group md-layout-item md-size-30 md-small-size-100">
        <label for="f_room">{{$t('Room')}}</label>
        <md-select v-model="filters.room" name="f_room" md-dense>
          <md-option>{{$t('Show all')}}</md-option>
          <md-option v-for="v in lookups.rooms" :key="v" :value="v">{{v}}</md-option>
        </md-select>
      </md-field>
      -->
    </div>

    <div class="md-layout md-layout-item md-size-100">
      <div class="ml-auto">
        <md-button
          @click="loadData(false);"
          class="md-round md-primary md-sm md-blue-border"
          style="margin:0px"
        >{{$t('Search')}}</md-button>
      </div>
    </div>
    <tabs
      :tab-active="1"
      :tab-name="dates"
      :tab-title="tabTitles"
      plain
      color-button="primary"
      @onChange="onTabChanged"
    >
      <div
        v-for="(date, index) in dates"
        :key="date"
        :slot="getTabName(index+1)"
        style="margin-top:32px"
      >
        <template v-if="!isToday">
          <div v-for="item in items" :key="item.gid">
            <panel-item
              v-if="item.itemType == 0"
              :item="item"
              :showThematicPath="true"
              :showDetailsLink="true"
              :showLogo="true"
            ></panel-item>
            <cultural-event-item
              v-if="item.itemType == 1"
              :item="item"
              :showThematicPath="true"
              @showDetails="onShowCulturalEventDetails(item)"
            ></cultural-event-item>
            <special-event-item
              v-if="item.itemType == 2"
              :item="item"
              @showDetails="onShowSpecialEventDetails(item)"
            ></special-event-item>
            <hour-slot-item v-if="item.itemType == 3" :item="item"></hour-slot-item>
          </div>
        </template>

        <template v-else>
          <template v-if="recommendedItems.length">
            <div class="agenda-section-label">{{ $t('Recommended events') }}</div>
            <div v-for="item in recommendedItems" :key="item.gid">
              <panel-item
                v-if="item.itemType == 0"
                :item="item"
                :showThematicPath="true"
                :showDetailsLink="true"
                :showLogo="true"
              ></panel-item>
              <cultural-event-item
                v-if="item.itemType == 1"
                :item="item"
                :showThematicPath="true"
                @showDetails="onShowCulturalEventDetails(item)"
              ></cultural-event-item>
              <special-event-item
                v-if="item.itemType == 2"
                :item="item"
                @showDetails="onShowSpecialEventDetails(item)"
              ></special-event-item>
              <hour-slot-item v-if="item.itemType == 3" :item="item"></hour-slot-item>
            </div>
          </template>

          <template v-if="currentAndFutureItems.length">
            <div class="agenda-section-label">{{ $t('Current and upcoming') }}</div>
          </template>
          <div v-for="item in currentAndFutureItems" :key="item.gid">
            <panel-item
              v-if="item.itemType == 0"
              :item="item"
              :showThematicPath="true"
              :showDetailsLink="true"
              :showLogo="true"
            ></panel-item>
            <cultural-event-item
              v-if="item.itemType == 1"
              :item="item"
              :showThematicPath="true"
              @showDetails="onShowCulturalEventDetails(item)"
            ></cultural-event-item>
            <special-event-item
              v-if="item.itemType == 2"
              :item="item"
              @showDetails="onShowSpecialEventDetails(item)"
            ></special-event-item>
            <hour-slot-item v-if="item.itemType == 3" :item="item"></hour-slot-item>
          </div>

          <template v-if="pastItems.length">
            <div class="agenda-section-label">{{ $t('Ended') }}</div>
            <div v-for="item in pastItems" :key="item.gid">
              <panel-item
                v-if="item.itemType == 0"
                :item="item"
                :showThematicPath="true"
                :showDetailsLink="true"
                :showLogo="true"
              ></panel-item>
              <cultural-event-item
                v-if="item.itemType == 1"
                :item="item"
                :showThematicPath="true"
                @showDetails="onShowCulturalEventDetails(item)"
              ></cultural-event-item>
              <special-event-item
                v-if="item.itemType == 2"
                :item="item"
                @showDetails="onShowSpecialEventDetails(item)"
              ></special-event-item>
              <hour-slot-item v-if="item.itemType == 3" :item="item"></hour-slot-item>
            </div>
          </template>
        </template>
      </div>
    </tabs>
    <!-- 
    <div class="modal modal-bg" :class="{ show: selectedEventItem }">
      <modal v-if="selectedEventItem" @close="selectedEventItem = null">
        <template slot="header">
          <h3 class="title text-center">{{selectedEventItem.description.topic}}</h3>
          <md-button
            class="md-simple md-close md-just-icon md-round modal-default-button"
            @click="selectedEventItem = null"
          >
            <md-icon>clear</md-icon>
          </md-button>
        </template>

        <template slot="body">
          <div v-html="selectedEventItemHtml" />
        </template>
      </modal>
    </div>-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "@/util/axios";
import { Tabs } from "@/components";
//import { Modal } from "@/components";
import PanelItem from "./PanelListItem";
import CulturalEventItem from "./CulturalEventListItem";
import SpecialEventItem from "./SpecialEventListItem";
import HourSlotItem from "./HourSlotListItem";

export default {
  components: {
    Tabs,
    //Modal,
    PanelItem,
    HourSlotItem,
    CulturalEventItem,
    SpecialEventItem
  },
  props: ["dates"],
  data() {
    return {
      selectedEventItem: null,
      selectedEventItemHtml: null,
      items: [],
      filters: { date: null },
      lookups: {
        thematicPaths: [],
        rooms: [],
        panelTypes: []
      },
      now: new Date()
    };
  },
  computed: {
    ...mapGetters({
      conference: "conference/current",
      language: "language/current",
      agendaSettings: "user/agendaSettings"
    }),

    isToday() {
      if (!this.filters.date) return false;
      const tabDate = new Date(this.filters.date);
      return (
        this.now.getFullYear() === tabDate.getFullYear() &&
        this.now.getMonth() === tabDate.getMonth() &&
        this.now.getDate() === tabDate.getDate()
      );
    },
    recommendedItems() {
      return this.items.filter(i => i.isRecommended && !this.isPast(i));
    },
    currentAndFutureItems() {
      return this.items.filter(i => !i.isRecommended && !this.isPast(i));
    },
    pastItems() {
      return this.items.filter(i => this.isPast(i));
    },

    tabTitles: function() {
      return this.dates.map((d, i) =>
        this.agendaSettings.showDate
          ? `${this.$t("Day")} ${i + 1} (${this.$moment(d).format(
              "YYYY-MM-DD"
            )})`
          : `${this.$t("Day")} ${i + 1}`
      );
    }
  },
  methods: {
    isPast(item) {
      if (!item.endDate) return false;
      return new Date(item.endDate) <= this.now;
    },
    async loadLookups() {
      let loader = this.$loading.show({ container: this.$refs.page });
      try {
        this.lookups = (
          await axios.get("public/panels/lookups", {
            params: {
              year: this.conference.year,
              type: this.conference.type,
              language: this.language.code
            }
          })
        ).data;
      } finally {
        this.loaded = true;
        loader.hide();
      }
    },
    async loadData(reload) {
      let loader = this.$loading.show({ container: this.$refs.page });
      try {
        if (reload) {
          await this.loadLookups();
        }

        var parsedFilters = { ...this.filters };

        parsedFilters.thematicPath = !!parsedFilters.thematicPath
          ? parsedFilters.thematicPath
          : null;
        parsedFilters.panelType = !!parsedFilters.panelType
          ? parsedFilters.panelType
          : null;
        parsedFilters.room = !!parsedFilters.room ? parsedFilters.room : null;

        this.items = (
          await axios.get("public/panels", {
            params: {
              year: this.conference.year,
              type: this.conference.type,
              language: this.language.code,
              ...parsedFilters
            }
          })
        ).data;
        // eslint-disable-next-line no-console
        console.log("model: ", this.items)
      } finally {
        this.loaded = true;
        loader.hide();
      }
    },
    getTabName(index) {
      return "tab-pane-" + index + "";
    },
    async onTabChanged(key) {
      this.filters.date = key;
      await this.loadData(true);
    },
    async onShowCulturalEventDetails(item) {
      let result = (
        await axios.get(
          "public/conferences/conference/cultural-events/details",
          {
            params: {
              id: item.id,
              language: this.language.code
            }
          }
        )
      ).data;

      // this.selectedEventItemHtml = result;
      // this.selectedEventItem = item;

      var selectedItemResult = { topic: item.description.topic, html: result };

      this.$emit("selectedItem", selectedItemResult);
    },
    async onShowSpecialEventDetails(item) {
      let result = (
        await axios.get(
          "public/conferences/conference/special-events/details",
          {
            params: {
              id: item.id,
              language: this.language.code
            }
          }
        )
      ).data;

      // this.selectedEventItemHtml = result;
      // this.selectedEventItem = item;

      var selectedItemResult = { topic: item.description.topic, html: result };

      this.$emit("selectedItem", selectedItemResult);
    },
    async print() {
      let loader = this.$loading.show({ container: this.$refs.page });

      try {
        await axios.downloadAgendaFile(
          "public/conferences/conference/printAgenda",
          {
            year: this.conference.year,
            type: this.conference.type,
            language: this.language.code
          }
        );
      } finally {
        loader.hide();
      }
    }
  },
  watch: {
    async conference() {
      await this.loadData(true);
    },
    async language() {
      this.items = [];
      await this.loadData(true);
    }
  },
  async mounted() {
    this.filters.date = this.dates[0];
    await this.loadData(true);
    this._nowTimer = setInterval(() => { this.now = new Date(); }, 60000);
    const savedY = sessionStorage.getItem('panelsScrollY');
    if (savedY) {
      sessionStorage.removeItem('panelsScrollY');
      this.$nextTick(() => window.scrollTo(0, parseInt(savedY)));
    }
  },
  beforeDestroy() {
    clearInterval(this._nowTimer);
  }
};
</script>

<style lang="scss" scoped>
.agenda-section-label {
  font-size: 13px;
  font-weight: 600;
  color: #aaaaaa;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin: 24px 0 4px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #eeeeee;
}
</style>
